// extracted by mini-css-extract-plugin
export default {"cursorDot":"CustomCursor_cursorDot__DKd8Q","cursorRing":"CustomCursor_cursorRing__gmqK5","cursorGlow":"CustomCursor_cursorGlow__ilFF8","activeGlow":"CustomCursor_activeGlow__Ll5jY"};